// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"10f48d7c","560":"8bfc70c2","650":"9ac2e70a"}[chunkId] + ".chunk.css";
};